import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-address-display-text',
  templateUrl: './address-display-text.component.html',
  styleUrls: ['./address-display-text.component.scss']
})
export class AddressDisplayTextComponent implements OnInit {
  @Input() fullAddress: FullAddress;
  @Input() bold: boolean;
  @Input() cardClassName: string;
  addressTex1: string;
  addressTex2: string;

  constructor() { }

  ngOnInit() {
    this.getAddressDisplayText();
  }

  getAddressDisplayText(): void {
    this.addressTex1 = `${this.fullAddress.address1} ${this.fullAddress.address2 ? this.fullAddress.address2 : ''}`;
    this.addressTex2 = `${this.fullAddress.city ? this.fullAddress.city : ''},
      ${this.fullAddress.state}
      ${this.fullAddress.zipCode}`;
  }

}
